import styled, { css } from 'styled-components';

import { TransientProps } from '@common/types';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const BottomPanel = styled.div`
  ${({ theme }) => css`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${theme.colors.background[40]};
    overflow: hidden;
  `}
`;

export const CarouselNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
  padding: 0.5rem 1rem 0;
`;

export const CarouselDot = styled.button<{ $active: boolean }>`
  ${({ theme, $active }) => css`
    width: ${$active ? '1.25rem' : '0.375rem'};
    height: 0.375rem;
    border-radius: 0.1875rem;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    background: ${$active
      ? theme.colors.brand.primary.default
      : theme.colors.background[40]};
    padding: 0;
  `}
`;

export const CarouselTrack = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
  overflow: hidden;
`;

type SlideProps = TransientProps<{ visible: boolean }>;

export const CarouselSlide = styled.div<SlideProps>`
  ${({ $visible }) => css`
    position: absolute;
    inset: 0;
    overflow-y: auto;
    transition: opacity 0.6s ease-in-out;
    opacity: ${$visible ? 1 : 0};
    pointer-events: ${$visible ? 'auto' : 'none'};

    &::-webkit-scrollbar {
      width: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.08);
      border-radius: 3px;
    }
  `}
`;
